import setPayment from './setPayment'

export default function setCalculatedValues(e, t, a, n, s, o, m, l, r, c) {
    const
        cAmount = document.querySelector(".calc-amount"),
        cMonth = document.querySelector(".calc-month"),
        cMonthlyPay = document.querySelectorAll(".calc-monthlyPay"),
        cDebitRent = document.querySelector(".calc-debitrente"),
        cCreditTotal = document.querySelector(".calc-creditTotal"),
        cAOP = document.querySelectorAll(".calc-aop"),
        cTotalCreditCost = document.querySelectorAll(".calc-totalkreditcost"),
        cCreditCost = document.querySelectorAll(".calc-kreditcost"),
        cInsurancePrice = document.querySelectorAll('.calc-insuranceprice'),
        cSetupFeeLoan = document.querySelectorAll(".calc-setupfeeloan");

    if (cAmount) {
        cAmount.innerHTML = e;
    }
    if (cMonth) {
        cMonth.innerHTML = t;
    }
    if (cMonthlyPay) {
        for (let i = 0; i < cMonthlyPay.length; i++) {
            cMonthlyPay[i].innerHTML = a;
        }        
    }
    if (cDebitRent) {
        cDebitRent.innerHTML = n;
    }
    if (cCreditTotal) {
        cCreditTotal.innerHTML = s;
    }
    if (cAOP) {
        for (let i = 0; i < cAOP.length; i++) {
            cAOP[i].innerHTML = o;
        } 
    }
    if (cTotalCreditCost) {
        for (let i = 0; i < cTotalCreditCost.length; i++) {
            cTotalCreditCost[i].innerHTML = m;
        } 
    }
    if (cCreditCost) {
        for (let i = 0; i < cCreditCost.length; i++) {
            cCreditCost[i].innerHTML = l;
        } 
    }
    if (cSetupFeeLoan) {
        for (let i = 0; i < cSetupFeeLoan.length; i++) {
            cSetupFeeLoan[i].innerHTML = r;
        }
    }
    if (cInsurancePrice) {
        for (let i = 0; i < cInsurancePrice.length; i++) {
            cInsurancePrice[i].innerHTML = c;
        }
    }
}